import React from 'react';
import { createRoot } from 'react-dom/client';
import { injectTalk2ViewChatStyles } from '@talk2view/sdk/chat';
import { App } from './App';

// Make this WebView easy to find in Safari Develop menu.
document.title = `Talk2View Taskpane · ${new Date().toLocaleTimeString()}`;

// eslint-disable-next-line no-console
console.log(
  '%c[TASKPANE BOOT]',
  'background:#111;color:#0f0;font-weight:bold;padding:2px 6px;border-radius:3px',
  new Date().toISOString(),
  { url: window.location.href, userAgent: navigator.userAgent },
);

Office.onReady((info) => {
  // eslint-disable-next-line no-console
  console.log('[Office.onReady]', info);

  // The chat's stylesheet, installed as a sheet rather than imported as CSS:
  // this add-in's webpack declares no rule for .css, so `import
  // '@talk2view/sdk/chat.css'` would fail the build. Called here, once, before
  // the first paint — never from a render path, which can run twice. Never add
  // a CSS loader and the import as well; that would install the sheet twice.
  injectTalk2ViewChatStyles();

  const container = document.getElementById('root');
  if (!container) {
    console.error('[TASKPANE] Root element not found');
    throw new Error('Root element not found');
  }
  const root = createRoot(container);
  root.render(<App />);
  // eslint-disable-next-line no-console
  console.log('[TASKPANE] React mounted');
});

window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[TASKPANE] uncaught error', e.error ?? e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[TASKPANE] unhandled promise rejection', e.reason);
});
